import styled from 'styled-components';

export const ImgCropperModalStyle = styled.div`
  .cropperWrap {
    margin: auto;
  }

  .crop-info {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    border: 1px solid #e8e7ee;
  }

  .preview-btn {
    margin: 5px 0;
  }

  .rotate-btn {
    margin-right: 10px;
  }

  .notify {
    font-size: 13px;
    font-weight: bold;
    color: red;
  }

  .cropper-crop-box {
    width: 300px !important;
    height: 300px !important;
  }
`;
